import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { GlobalStyle } from '../../global/global';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { ImplementationTable } from './implementationTable';
import {
    Box,
    Flex,
    Text,
    Image,
    Show,
    Button,
    Link,
} from '@chakra-ui/react';
import { useRef, useState, useEffect } from 'react';
import StyledButton from '../../components/Button/Button';
import ModalSection from '../../sections/ModalSection/ModalSection';
import { modalProps } from './implementationModal';

interface Props {}

export default function PackagesPage(props: Props) {
    const sectionAbonamentyRef = useRef<HTMLDivElement | null>(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCrossborderVisible, setIsCrossborderVisible] = useState(false);
    const [isAtBottom, setIsAtBottom] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (sectionAbonamentyRef.current) {
                const rect = sectionAbonamentyRef.current.getBoundingClientRect();
                const isVisible = rect.top <= window.innerHeight - 400 && rect.bottom >= 400;
                setIsCrossborderVisible(isVisible);
            }

            const bottomThreshold = 0;
            const isBottom =
                window.innerHeight + window.scrollY >= document.body.offsetHeight - bottomThreshold;
            setIsAtBottom(isBottom);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const fullModalProps = {
        ...modalProps,
        isOpen: isModalOpen,
        onClose: handleCloseModal,
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Zbuduj profesjonalny sklep z IdoSell"
                subTitle="Nasi Specjaliści przeprowadzą Cię przez proces tworzenia sklepu lub migracji, korzystając ze sprawdzonych rozwiązań IdoSell."
                image={{
                    url: 'https://www.idosell.com/panel/file-gate.php?id=302431&ext=.webp',
                    alt: 'Uśmiechnięci ludzie patrzący na ekran monitora',
                }}
                buttons={[
                    {
                        title: 'Zamów sklep',
                        href: 'https://www.idosell.com/pl/order/',
                        variant: 'default',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    mt={{
                        base: '55px',
                        md: '40px',
                        lg: '45px',
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Box id="additional_info">
                        <Flex
                            mb="75px"
                            padding={{ base: '0 15px', md: '0' }}
                            flexWrap={'wrap'}
                            alignItems="flex-start"
                            justifyContent={{
                                base: 'center',
                                md: 'space-between',
                            }}
                        >
                            <Flex
                                id="pakiety"
                                width={{
                                    base: '100%',
                                    md: '44%',
                                    xl: '42%',
                                }}
                                direction={'column'}
                                position={'relative'}
                                border="2px solid transparent"
                                padding={{
                                    md: '15px 0',
                                    lg: '0',
                                }}
                            >
                                <Box
                                // minH={{
                                //     md: '700px',
                                // }}
                                // mb={3}
                                >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height={{
                                            base: '120px',
                                            lg: '215px',
                                            xl: '266px',
                                        }}
                                    >
                                        <Show below="lg">
                                            <Image
                                                maxH={'100%'}
                                                m={'auto'}
                                                src="https://www.idosell.com/panel/file-gate.php?id=480044&ext=.svg"
                                            />
                                        </Show>
                                        <Show above="lg">
                                            <Image
                                                maxH={'100%'}
                                                m={'auto'}
                                                src="https://www.idosell.com/panel/file-gate.php?id=478398&ext=.svg"
                                            />
                                        </Show>
                                    </Box>
                                    <Text
                                        fontWeight={'600'}
                                        fontSize={{
                                            base: '16px',
                                            lg: '26px',
                                        }}
                                        textAlign={'center'}
                                        // color={'white'}
                                        lineHeight={{
                                            base: 'normal',
                                            lg: '34px',
                                        }}
                                        mt={{
                                            base: '20px',
                                            lg: '35px,',
                                        }}
                                    >
                                        Pakiety wdrożeniowe
                                    </Text>
                                    <Text
                                        textAlign={'center'}
                                        fontSize={{ base: '15px', lg: '18px' }}
                                        lineHeight={{
                                            base: '1.6',
                                            lg: 'normal',
                                        }}
                                    >
                                        Wybierz najkorzystniejszy pakiet, kontaktując się z naszym
                                        Opiekunem handlowym
                                    </Text>
                                </Box>
                            </Flex>

                            <Box
                                my={'15px'}
                                display={'flex'}
                                justifyContent={'center'}
                                alignSelf="center"
                                w={{
                                    base: '100%',
                                    md: 'auto',
                                }}
                                position={'relative'}
                                // sx={{
                                //     _before: {
                                //         content: ['""', null, 'none'], // Note: Double quotes inside single quotes
                                //         width: '100%',
                                //         height: '2px',
                                //         position: 'absolute',
                                //         left: '0',
                                //         top: '6px',
                                //         borderBottom: '3px dotted white',
                                //         borderLeftStyle: 'dotted',
                                //         borderRightStyle: 'dotted',
                                //         borderLeftColor: 'white',
                                //         borderRightColor: 'white',
                                //     },
                                // }}
                            >
                                <Show above="xl">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="46"
                                        height="45"
                                        viewBox="0 0 46 45"
                                        fill="none"
                                    >
                                        <path
                                            d="M25.8699 19.6924V0H20.1301V19.6924H0V25.3076H20.1301V45H25.8699V25.3076H46V19.6924H25.8699Z"
                                            fill="#171717"
                                        />
                                    </svg>
                                </Show>
                                <Show below="xl">
                                    <Box
                                        zIndex={2}
                                        // backgroundColor={'#1AAC7A'}
                                        px={2}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.3726 9.62742V0H9.62742V9.62742H0V12.3726H9.62742V22H12.3726V12.3726H22V9.62742H12.3726Z"
                                                fill="#171717"
                                            />
                                        </svg>
                                    </Box>
                                </Show>
                            </Box>

                            <Flex
                                id="crossborder"
                                width={{
                                    base: '100%',
                                    md: '44%',
                                    xl: '42%',
                                }}
                                direction={'column'}
                                border="2px solid #171717"
                                padding={{
                                    base: '15px 30px',
                                    xl: '0 30px 30px',
                                }}
                            >
                                <Box
                                // minH={{
                                //     md: '700px',
                                // }}
                                // mb={3}
                                >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height={{
                                            base: '120px',
                                            lg: '200px',
                                            xl: '266px',
                                        }}
                                    >
                                        <Image
                                            m={'auto'}
                                            maxHeight={{ base: '100%', xl: '206px' }}
                                            src="https://www.idosell.com/panel/file-gate.php?id=478397&ext=.svg"
                                        />
                                    </Box>
                                    <Text
                                        fontWeight={'600'}
                                        fontSize={{
                                            base: '16px',
                                            lg: '26px',
                                        }}
                                        lineHeight={{
                                            base: 'normal',
                                            lg: '34px',
                                        }}
                                        textAlign={'center'}
                                        // color={'white'}
                                        mt={{
                                            base: '20px',
                                            lg: '35px,',
                                        }}
                                    >
                                        Crossborder
                                    </Text>
                                    <Text
                                        textAlign={'center'}
                                        fontSize={{ base: '15px', lg: '18px' }}
                                        lineHeight={{
                                            base: '1.6',
                                            lg: 'normal',
                                        }}
                                    >
                                        Rozpocznij międzynarodową sprzedaż, dostosowując swój sklep
                                    </Text>
                                </Box>
                            </Flex>
                        </Flex>
                    </Box>
                    <Box ref={sectionAbonamentyRef}>
                        <ImplementationTable />
                    </Box>
                    <Box padding={'0 15px'}>
                        <CTASection
                            buttons={[
                                {
                                    title: 'Zamów sklep',
                                    href: 'https://www.idosell.com/pl/order/',
                                    variant: 'default',
                                },
                                {
                                    title: 'Umów się na spotkanie',
                                    href: 'https://eu1.hubs.ly/H08swyQ0',
                                    variant: 'outline',
                                },
                            ]}
                            padding="50px 0"
                        />
                    </Box>
                    <Flex
                        id="bottom_links"
                        flexDirection="column"
                        alignItems="center"
                        marginBottom="80px"
                        marginTop="45px"
                    >
                        <Text
                            fontSize="18px"
                            fontWeight="600"
                            textAlign="center"
                            color="#1AAC7A"
                            position="relative"
                            paddingBottom="15px"
                            marginBottom="25px"
                            _after={{
                                content: '""',
                                position: 'absolute',
                                bottom: '0',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '66px',
                                height: '4px',
                                backgroundColor: '#171717',
                            }}
                        >
                            Zobacz więcej
                        </Text>
                        <Link
                            display={'flex'}
                            alignItems={'center'}
                            fontWeight={'700'}
                            transition={'.2s'}
                            _hover={{
                                color: '#DD1C4A',
                                svg: {
                                    fill: '#DD1C4A',
                                },
                            }}
                            href="https://www.idosell.com/pl/szczegolowy-cennik-idosell/"
                            lineHeight={'18px'}
                            marginLeft={{base:"25px", sm: "0"}}
                        >
                            <Text
                                as={'span'}
                                marginRight={'15px'}
                                fontSize={'14px'}
                                flexGrow={0}
                                textAlign={'center'}
                                maxWidth={{
                                    base: "276px",
                                    sm: "none"
                                }}
                            >
                                Szczegółowy zakres i cennik pakietów wdrożeniowych
                            </Text>
                            <Box flexShrink={0} maxH={'13px'}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="13"
                                    viewBox="0 0 10 14"
                                    fill="none"
                                >
                                    <path
                                        d="M0.799805 13.9998H3.50569L9.19981 7.38543L3.50569 0.799805H0.799805L6.49392 7.38543L0.799805 13.9998Z"
                                        fill="#171717"
                                    />
                                </svg>
                            </Box>
                        </Link>
                        <Link
                            display={'flex'}
                            alignItems={'center'}
                            fontWeight={'700'}
                            transition={'.2s'}
                            _hover={{
                                color: '#DD1C4A',
                                svg: {
                                    fill: '#DD1C4A',
                                },
                            }}
                            href="https://www.idosell.com/panel/file-gate.php?id=322502&lang=pl&ext=.pdf"
                            marginTop="20px"
                            marginLeft={{base:"25px", sm: "0"}}
                        >
                            <Text
                                as={'span'}
                                marginRight={'15px'}
                                fontSize={'14px'}
                                flexGrow={0}
                                textAlign={'center'}
                                lineHeight={'18px'}
                                maxWidth={{
                                    base: "233px",
                                    sm: "none"
                                }}
                            >
                                Regulamin prac wdrożeniowych IdoSell
                            </Text>
                            <Box flexShrink={0}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="13"
                                    viewBox="0 0 10 14"
                                    fill="none"
                                >
                                    <path
                                        d="M0.799805 13.9998H3.50569L9.19981 7.38543L3.50569 0.799805H0.799805L6.49392 7.38543L0.799805 13.9998Z"
                                        fill="#171717"
                                    />
                                </svg>
                            </Box>
                        </Link>
                    </Flex>
                </Box>
            </div>
            <Box
                id="crossborder"
                position="fixed"
                bottom="0"
                left="50%"
                //transform="translateX(-50%) translateY(100%)"
                transform={`translateX(-50%) translateY(${
                    isCrossborderVisible && !isAtBottom ? '0' : '100%'
                })`}
                transition="transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out"
                zIndex="999"
                width="1200px"
                margin="0 auto"
                maxW="95%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                padding="15px 0"
                sx={{
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: '0',
                        left: '50%',
                        bottom: '0',
                        backgroundColor: '#fff',
                        width: '100vw',
                        transform: 'translateX(-50%)',
                        zIndex: '-1',
                        boxShadow: '0px -4px 16px 0px rgba(0, 0, 0, 0.16);',
                    },
                }}
            >
                <Box
                    marginRight="10px"
                    alignItems="center"
                    display={{
                        base: 'block',
                        lg: 'flex',
                    }}
                >
                    <Box display="flex" alignItems="center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 22 22"
                            fill="none"
                        >
                            <path
                                d="M19.5938 11C19.5938 11.2735 19.4851 11.5358 19.2917 11.7292C19.0983 11.9226 18.836 12.0312 18.5625 12.0312H12.0312V18.5625C12.0312 18.836 11.9226 19.0983 11.7292 19.2917C11.5358 19.4851 11.2735 19.5938 11 19.5938C10.7265 19.5938 10.4642 19.4851 10.2708 19.2917C10.0774 19.0983 9.96875 18.836 9.96875 18.5625V12.0312H3.4375C3.164 12.0312 2.90169 11.9226 2.7083 11.7292C2.5149 11.5358 2.40625 11.2735 2.40625 11C2.40625 10.7265 2.5149 10.4642 2.7083 10.2708C2.90169 10.0774 3.164 9.96875 3.4375 9.96875H9.96875V3.4375C9.96875 3.164 10.0774 2.90169 10.2708 2.7083C10.4642 2.5149 10.7265 2.40625 11 2.40625C11.2735 2.40625 11.5358 2.5149 11.7292 2.7083C11.9226 2.90169 12.0312 3.164 12.0312 3.4375V9.96875H18.5625C18.836 9.96875 19.0983 10.0774 19.2917 10.2708C19.4851 10.4642 19.5938 10.7265 19.5938 11Z"
                                fill="#171717"
                            />
                        </svg>
                        <Text
                            as="strong"
                            fontSize="21px"
                            fontWeight="600"
                            color="#FEB92F"
                            display="block"
                            marginLeft="15px"
                        >
                            Cross-border
                        </Text>
                    </Box>
                    <Text
                        fontSize="12px"
                        lineHeight="1.6"
                        marginLeft={{
                            base: '33px',
                            lg: '20px',
                        }}
                        maxWidth="365px"
                    >
                        Pakiet, dzięki któremu kompleksowo dostosujesz swój sklep do sprzedaży na rynkach zagranicznych
                    </Text>
                </Box>

                <Show above="lg">
                    <StyledButton style={'default'} target={''} onClick={handleOpenModal}>
                        Czytaj więcej
                    </StyledButton>
                </Show>
                <Show below="lg">
                    <Button
                        onClick={handleOpenModal}
                        width="50px"
                        height="50px"
                        background="#fff"
                        border="2px solid #171717"
                        borderRadius="0"
                    >
                        <svg
                            width="9"
                            height="14"
                            viewBox="0 0 9 14"
                            fill="#171717"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                        </svg>
                    </Button>
                </Show>
            </Box>
            <ModalSection {...fullModalProps} />
        </ThemeProvider>
    );
}